import contextCreator from "../contextCreator";
import authReducer, { initialState } from "./auth.reducer";

// eslint-disable-next-line react-hooks/rules-of-hooks
const [state, dispatch, provider] = contextCreator(authReducer, initialState);

export const useAuthState = state;
export const useAuthDispatch = dispatch;
export const AuthProvider = provider;
